/**
 * @generated SignedSource<<6a9feb18a086672cc584cef0b5ab5449>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientAssetsPage_project$data = {
  readonly id: string;
  readonly tasks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly clientAssets: ReadonlyArray<{
    readonly id: string;
    readonly assetType: string;
    readonly name: string;
    readonly note: string | null;
    readonly status: string;
    readonly closureMode: string | null;
    readonly requiresReadAck: boolean;
    readonly dueDate: string | null;
    readonly psaTaskId: string | null;
    readonly taskName: string | null;
    readonly archived: boolean;
    readonly createdAt: string;
    readonly currentVersion: {
      readonly id: string;
      readonly versionNo: number;
      readonly fileName: string;
      readonly sizeBytes: number;
      readonly downloadUrl: string | null;
      readonly createdAt: string;
      readonly uploadedByFirm: boolean;
      readonly uploadedByEmail: string | null;
    } | null;
    readonly versions: ReadonlyArray<{
      readonly id: string;
      readonly versionNo: number;
      readonly fileName: string;
      readonly sizeBytes: number;
      readonly downloadUrl: string | null;
      readonly createdAt: string;
      readonly uploadedByFirm: boolean;
      readonly uploadedByEmail: string | null;
    }>;
    readonly responses: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly createdAt: string;
      readonly currentVersion: {
        readonly id: string;
        readonly fileName: string;
        readonly sizeBytes: number;
        readonly downloadUrl: string | null;
        readonly uploadedByEmail: string | null;
        readonly createdAt: string;
      } | null;
    }>;
    readonly readReceipts: ReadonlyArray<{
      readonly email: string;
      readonly versionNo: number;
      readonly readAt: string;
    }>;
  }> | null;
  readonly " $fragmentType": "ClientAssetsPage_project";
};
export type ClientAssetsPage_project$key = {
  readonly " $data"?: ClientAssetsPage_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientAssetsPage_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionNo",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sizeBytes",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "downloadUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadedByEmail",
  "storageKey": null
},
v8 = [
  (v0/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uploadedByFirm",
    "storageKey": null
  },
  (v7/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClientAssetsPage_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100000
        },
        {
          "kind": "Literal",
          "name": "simpleResponse",
          "value": true
        }
      ],
      "concreteType": "TaskTypeConnection",
      "kind": "LinkedField",
      "name": "tasks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "tasks(first:100000,simpleResponse:true)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientAsset",
      "kind": "LinkedField",
      "name": "clientAssets",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assetType",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "note",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "closureMode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiresReadAck",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dueDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "psaTaskId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "archived",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientAssetVersion",
          "kind": "LinkedField",
          "name": "currentVersion",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientAssetVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": (v8/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientAsset",
          "kind": "LinkedField",
          "name": "responses",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientAssetVersion",
              "kind": "LinkedField",
              "name": "currentVersion",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientAssetReadReceipt",
          "kind": "LinkedField",
          "name": "readReceipts",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "readAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};
})();

(node as any).hash = "40c85c32e298153d007f7e89c4a6052b";

export default node;
